import { CFormGroup, CLabel, CSwitch } from "@coreui/react";

import { FieldError } from "react-hook-form";
import React from "react";

interface BooleanFieldProps {
  name: string;
  label: string;
  description?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: FieldError;
  required?: boolean;
  testId?: string;
}

const BooleanField: React.FC<BooleanFieldProps> = ({
  name,
  label,
  description,
  value,
  onChange,
  error,
  required = false,
  testId,
}) => {
  return (
    <CFormGroup>
      <div className="d-flex justify-content-between align-items-center">
        <CLabel htmlFor={name} className="mb-0">
          {label}
          {required && <span className="text-danger"> *</span>}
        </CLabel>
        <CSwitch
          id={name}
          name={name}
          data-testid={testId}
          checked={value}
          onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
          color="primary"
        />
      </div>
      {description && (
        <small className="form-text text-muted mt-1 d-block">
          {description}
        </small>
      )}
      {error && (
        <div className="invalid-feedback d-block mt-1">{error.message}</div>
      )}
    </CFormGroup>
  );
};

export default BooleanField;
